(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["story-timeline"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const timeline = document.querySelector('.story-timeline');
  if (!timeline) return;

  // Check if animations are enabled
  const enableAnimations = timeline.dataset.enableAnimations !== 'false';
  const animationLibrary = timeline.dataset.animationLibrary || 'css';
  const reducedMotionRespect = timeline.dataset.reducedMotionRespect !== 'false';
  
  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotionRespect && prefersReducedMotion) {
    enableAnimations = false;
  }

  if (!enableAnimations) return;

  // CSS Animation Path
  if (animationLibrary === 'css') {
    initCSSAnimations();
  }
  // GSAP Animation Path
  else if (animationLibrary === 'gsap' && window.gsap && window.ScrollTrigger) {
    initGSAPAnimations();
  }
  // Fallback to CSS
  else {
    initCSSAnimations();
  }

  function initCSSAnimations() {
    const spineLine = timeline.querySelector('.story-timeline__spine-line');
    const spineDots = timeline.querySelectorAll('.story-timeline__spine-dot');
    const milestones = timeline.querySelectorAll('.story-timeline__milestone');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Spine draw animation
          if (spineLine && !spineLine.classList.contains('is-drawn')) {
            setTimeout(() => {
              spineLine.classList.add('is-drawn');
            }, 200);
          }
          
          // Dot pop animations
          if (spineDots.length > 0) {
            spineDots.forEach((dot, index) => {
              setTimeout(() => {
                dot.classList.add('is-visible');
              }, 400 + (index * 100));
            });
          }
          
          // Card stagger animations
          if (milestones.length > 0) {
            milestones.forEach((milestone, index) => {
              setTimeout(() => {
                milestone.classList.add('is-inview');
              }, 600 + (index * 80));
            });
          }
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(timeline);
  }

  function initGSAPAnimations() {
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    
    // Register ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);
    
    const spineLine = timeline.querySelector('.story-timeline__spine-line');
    const spineDots = timeline.querySelectorAll('.story-timeline__spine-dot');
    const milestones = timeline.querySelectorAll('.story-timeline__milestone');
    
    // Create main timeline
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: timeline,
        start: 'top 70%',
        end: 'bottom 30%',
        toggleActions: 'play none none reverse'
      }
    });
    
    // Spine draw animation
    if (spineLine) {
      tl.fromTo(spineLine, 
        { scaleY: 0 },
        { scaleY: 1, duration: 0.8, ease: 'power2.out' },
        0
      );
    }
    
    // Dot pop animations
    if (spineDots.length > 0) {
      spineDots.forEach((dot, index) => {
        tl.fromTo(dot,
          { scale: 0, opacity: 0 },
          { 
            scale: 1, 
            opacity: 1, 
            duration: 0.4, 
            ease: 'back.out(1.7)',
            onComplete: () => {
              gsap.to(dot, { scale: 1.12, duration: 0.2, yoyo: true, repeat: 1 });
            }
          },
          0.4 + (index * 0.1)
        );
      });
    }
    
    // Card stagger animations
    if (milestones.length > 0) {
      milestones.forEach((milestone, index) => {
        const isLeft = milestone.classList.contains('story-timeline__milestone--left');
        const startX = isLeft ? -24 : 24;
        
        tl.fromTo(milestone,
          { x: startX, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: 'power2.out' },
          0.6 + (index * 0.08)
        );
        
        // Connector animation
        const connector = milestone.querySelector('.story-timeline__connector');
        if (connector) {
          tl.fromTo(connector,
            { scaleX: 0 },
            { scaleX: 1, duration: 0.32, ease: 'power2.out' },
            0.7 + (index * 0.08)
          );
        }
      });
    }
    
    // Scroll progress glow
    const glow = timeline.querySelector('.story-timeline__glow');
    if (glow) {
      gsap.to(glow, {
        y: timeline.offsetHeight,
        ease: 'none',
        scrollTrigger: {
          trigger: timeline,
          start: 'top top',
          end: 'bottom bottom',
          scrub: true
        }
      });
    }
  }

  // Hover interactions
  const milestoneCards = timeline.querySelectorAll('.story-timeline__milestone-card');
  milestoneCards.forEach(card => {
    card.addEventListener('mouseenter', handleCardHover);
    card.addEventListener('mouseleave', handleCardLeave);
    card.addEventListener('focusin', handleCardHover);
    card.addEventListener('focusout', handleCardLeave);
  });

  function handleCardHover(e) {
    const card = e.currentTarget;
    const image = card.querySelector('.story-timeline__milestone-image img');
    const content = card.querySelector('.story-timeline__milestone-content');
    
    if (image) {
      gsap.to(image, { scale: 1.03, duration: 0.3, ease: 'power2.out' });
    }
    
    if (content) {
      gsap.to(content, { y: -4, duration: 0.3, ease: 'power2.out' });
    }
  }

  function handleCardLeave(e) {
    const card = e.currentTarget;
    const image = card.querySelector('.story-timeline__milestone-image img');
    const content = card.querySelector('.story-timeline__milestone-content');
    
    if (image) {
      gsap.to(image, { scale: 1, duration: 0.3, ease: 'power2.out' });
    }
    
    if (content) {
      gsap.to(content, { y: 0, duration: 0.3, ease: 'power2.out' });
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
